// extracted by mini-css-extract-plugin
export default {"Arrow":"arrow_Arrow__1Fyef"};